// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"5dd566e2","488":"c8fdac39","490":"cb368270","496":"d7982a87","764":"65bfb991","911":"b5cdd7b8","948":"1e36b0e6"}[chunkId] + ".chunk.js";
};